import { Company } from "../../enums/Company";
import { SrcType } from "../../enums/SrcType";

export class CampaignCreationRequest{
    public ClientFullName!: string;
    public CampaignType!: string;
    public SrcType!: SrcType;
    public Company!: Company;
    public DailyBudget!: string;
    public SpecialAdCategoryCountries!: string;
    public DomainName!: string;
    public AdAccountId!: string;
    public States!: string[];
    public BrandRemarketingState!: string;
    public BrandRemarketingCity!: string;
}